
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});

var $743f1fc0fe4ee70b$exports = {};

(parcelRequire("fzRTW")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"ho08C\",\"mention.818c7e24.js\",\"kSjKH\",\"ProfileCard.761ae167.js\",\"8DoxJ\",\"modal.3fd9f746.js\",\"ffEVr\",\"vendors~editor_icon.47a978d6.js\",\"aHE9G\",\"vendors~editor_atlaskit.b650bb40.js\",\"joJy8\",\"vendors~editor_atlaskit.runtime.db4db0a1.js\",\"dTsOE\",\"modal.dc2d010b.js\",\"hcniL\",\"ProfileCard.bb20cc0e.js\",\"lvR1M\",\"recent.347526cd.js\",\"dUEf9\",\"location.b2899cd9.js\",\"eYDcz\",\"modal.839909e9.js\",\"joJy8\",\"vendors~editor_atlaskit.runtime.db4db0a1.js\",\"1Y6tF\",\"main.2de69596.js\",\"cGVng\",\"AgentProfileCard.d4b930a6.js\",\"aGZFn\",\"modal.5010df70.js\",\"kjZZD\",\"vendors~editor_icon-object.e97fc136.js\",\"ffEVr\",\"vendors~editor_icon.47a978d6.js\",\"kPKOV\",\"AgentProfileCard.6e0835d0.js\",\"c9Qqc\",\"auto-dev.998d58bd.js\",\"1TK6P\",\"auto-fix.07790e95.js\",\"grvAy\",\"auto-review.eb6c556a.js\",\"23K0q\",\"backlog-buddy.77803ebe.js\",\"3kQkj\",\"comms-crafter.37031eba.js\",\"6OXgE\",\"culture.46528ca4.js\",\"cbucA\",\"customer-insight.b71811cb.js\",\"bVhr1\",\"decision-director.cdf61897.js\",\"kE0QC\",\"feature-flag-avatar.c60bd9d5.js\",\"eVFXf\",\"generic-avatar.0faf04ac.js\",\"9FhBz\",\"hire-writer.9e73f27f.js\",\"6zB8z\",\"marketing-message-maestro.d95d5d6b.js\",\"eENGY\",\"my-user-manual.277d400f.js\",\"hmlb0\",\"okr-oracle.501b2473.js\",\"2NGxc\",\"ops-agent.6b999ec1.js\",\"bPgcq\",\"pitch-perfector.33d8fc56.js\",\"31b1q\",\"product-requirement.2b164fec.js\",\"8Lh9U\",\"release-notes.c909e5c4.js\",\"6ZzYJ\",\"research-scout.6dccd2a5.js\",\"410SS\",\"social-media-scribe.404e9147.js\",\"z3s9q\",\"team-connection.62db7c27.js\",\"9gqcE\",\"workflow-builder.48a79198.js\",\"d2yzT\",\"AgentProfileCard.11f04c03.js\",\"erM4f\",\"star-filled.1f795fb2.js\",\"6FSEq\",\"star.e20ad96e.js\",\"eb06U\",\"AgentProfileCard.791ae1e8.js\"]"));


//# sourceMappingURL=mention.runtime.7ff33c7b.js.map
